import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-placement',
  templateUrl: './student-placement.component.html',
  styleUrls: ['./student-placement.component.css']
})
export class StudentPlacementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
